import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import AppSidebar from "./AppSidebar";
import MobileDrawer from "./MobileDrawer";
import "./AppLayout.responsive.css";

export default function AppLayout({
  children,
  user,
  onLogout,
  theme,
  onToggleTheme,
}) {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 1180);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [desktopMenuOpen, setDesktopMenuOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 1180;
      setIsMobile(mobile);

      if (mobile) {
        setDesktopMenuOpen(false);
      } else {
        setDrawerOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleMenuToggle = () => {
    if (isMobile) {
      setDrawerOpen((prev) => !prev);
    } else {
      setDesktopMenuOpen((prev) => !prev);
    }
  };

  const handleCloseDrawer = () => setDrawerOpen(false);
  const handleCloseDesktopMenu = () => setDesktopMenuOpen(false);

  const menuOpen = isMobile ? drawerOpen : desktopMenuOpen;

  return (
    <>
      <Navbar
        user={user}
        onLogout={onLogout}
        theme={theme}
        onToggleTheme={onToggleTheme}
        onOpenMenu={handleMenuToggle}
        menuOpen={menuOpen}
      />

      {!isMobile && (
        <>
          <div
            className={`desktop-sidebar-backdrop ${
              desktopMenuOpen ? "show" : ""
            }`}
            onClick={handleCloseDesktopMenu}
          />

          <div
            className={`desktop-sidebar-panel ${
              desktopMenuOpen ? "open" : ""
            }`}
          >
            <AppSidebar
              user={user}
              onNavigate={handleCloseDesktopMenu}
              collapsed={false}
            />
          </div>
        </>
      )}

      <div
        className={`app-layout-shell ${
          desktopMenuOpen && !isMobile ? "menu-open" : ""
        }`}
      >
        <main className="app-layout-main">{children}</main>
      </div>

      {isMobile && (
        <MobileDrawer open={drawerOpen} onClose={handleCloseDrawer}>
          <AppSidebar
            user={user}
            onNavigate={handleCloseDrawer}
            collapsed={false}
          />
        </MobileDrawer>
      )}
    </>
  );
}